<template>
    <div class="flex relative text-black" v-touch:swipe="handleComponent"
         :class="hasDarkMode ? 'dark-mode' : 'light-mode'">
        <div class="w-64 fixed min-h-screen shadow-md z-5 flex flex-col bg-white transition"
             ref="sidebar"
             :style="canShowSidebar ? {transform: `translateX(0)`} : {transform: `translateX(-100%)`}">
            <div
                class="h-16 px-5 flex items-center justify-center bg-orange-500 text-white text-center font-bold text-2xl mb-5">
                <router-link class="text-white" :to="{ name: 'about' }">INTRANET</router-link>
                <font-awesome @click="switchMenu" class="md:invisible ml-auto" icon="bars"></font-awesome>
            </div>
            <md-list v-touch:tap="() => this.sidebarMenu ? this.sidebarMenu = false : null">
                <md-list-item exact :to="{ name: 'about' }">
                    <md-icon>access_time</md-icon>
                    <span class="md-list-item-text">Časovač</span>
                </md-list-item>
                <md-list-item md-expand>
                    <md-icon>work</md-icon>
                    <span class="md-list-item-text">Aktivita</span>
                    <md-list slot="md-expand">
                        <md-list-item exact :to="{ name: 'activities.list', params: {group: 'by_project'} }" class="md-inset">Podľa projektu</md-list-item>
                        <md-list-item exact :to="{ name: 'activities.list', params: {group: 'by_day'} }" class="md-inset">Podľa dní</md-list-item>
                        <md-list-item exact :to="{ name: 'activities.list', params: {group: 'all'} }" class="md-inset">Všeobecný prehľad</md-list-item>
                    </md-list>
                </md-list-item>
                <md-list-item :to="{ name: 'calendar' }">
                    <md-icon>calendar_today</md-icon>
                    <span class="md-list-item-text">Kalendár</span>
                </md-list-item>
                <md-list-item :to="{ name: 'projects.list' }">
                    <md-icon>folder</md-icon>
                    <span class="md-list-item-text">Projekty</span>
                </md-list-item>
                <md-list-item :to="{ name: 'clients.list' }">
                    <md-icon>person</md-icon>
                    <span class="md-list-item-text">Klienti</span>
                </md-list-item>
                <md-list-item v-if="$utils.hasPermission(user, 'SHOW_ALL_USERS')" :to="{ name: 'users.list' }">
                    <md-icon>people</md-icon>
                    <span class="md-list-item-text">Použivatelia</span>
                </md-list-item>
                <md-list-item v-if="$utils.hasPermission(user, 'SHOW_STATISTICS')" :to="{ name: 'stats' }">
                    <md-icon>show_chart</md-icon>
                    <span class="md-list-item-text">Štatistiky</span>
                </md-list-item>
                <md-list-item :to="{ name: 'settings' }">
                    <md-icon>settings</md-icon>
                    <span class="md-list-item-text">Nastavenia</span>
                </md-list-item>
            </md-list>
            <div class="darkModeSwitch mt-auto flex items-center justify-center py-3 bg-gray-100">
                <span class="mr-2 text-sm text-gray-600 font-light">Dark Mode</span>
                <toggle @input="() => switchDarkMode()" :value="hasDarkMode"/>
            </div>
            <div v-if="user.name" class="flex py-4 px-3 bg-gray-200 items-center">
                <span class="w-10 h-10 rounded-full bg-no-repeat bg-center text-white flex items-center justify-center"
                      :title="user.type.name"
                      :class="`bg-${user.color}`">{{ getInicials(user) }}</span>
                <div class="flex flex-col ml-2 text-sm">
                    <span class="font-bold">{{ user.name }}</span>
                    <span class="text-xs">{{ user.email }}</span>
                </div>
                <button @click="logout" class="ml-auto h-full text-gray-400 hover:text-gray-500 cursor-pointer">
                    <font-awesome icon="sign-out-alt"></font-awesome>
                </button>
            </div>
        </div>
        
        <div class="md:ml-64 w-full max-w-full overflow-x-hidden bg-gray min-h-screen bg-gray-100"
             v-touch:tap="() => this.sidebarMenu ? this.sidebarMenu = false : null">
            <timer-control/>
            
            <Transition
                :name="transitionName"
                :mode="transitionMode"
                :enter-active-class="transitionEnterActiveClass"
                @beforeLeave="beforeLeave"
                @enter="enter"
                @afterEnter="afterEnter"
            >
                <router-view></router-view>
            </Transition>
        </div>
        
        <Modal v-if="pinCodeModal"
               :show="pinCodeModal"
               :on-close-click="closePinCodeModal"
               :on-save-click="savePinCodeModal"
               :dissmissable="false"
               modal-title="Vytvorte svoj PIN"
               :close-button="false"
               :show-footer="pinWasFilled"
               :after-open="() => afterPinCodeModalOpen()">
            <p class="text-gray-500 text-sm my-3">Vitajte v systéme spoločnosti <a href="https://sixnet.sk/"
                                                                                   class="text-orange-500">Sixnet
                Internet Technologies</a>,</p>
            <p class="text-gray-500 text-sm">Pre vykonavanie a zobrazovanie citlivých údajov, bude potrebné zadávať PIN,
                aby sa predišlo zneužitiu účtu.</p>
            <div class="ml-auto mr-auto my-6">
                <input
                    placeholder="0" @keypress="pinKeyPress" type="text" name="input1" ref="pincode1"
                    class="w-10 py-2 border-b-2 border-gray-300 mx-2 focus:border-orange-500 text-2xl text-center">
                <input
                    placeholder="0" @keypress="pinKeyPress" type="text" name="input2" ref="pincode2"
                    class="w-10 py-2 border-b-2 border-gray-300 mx-2 focus:border-orange-500 text-2xl text-center">
                <input
                    placeholder="0" @keypress="pinKeyPress" type="text" name="input3" ref="pincode3"
                    class="w-10 py-2 border-b-2 border-gray-300 mx-2 focus:border-orange-500 text-2xl text-center">
                <input
                    placeholder="0" @keypress="pinKeyPress" type="text" name="input4" ref="pincode4"
                    class="w-10 py-2 border-b-2 border-gray-300 mx-2 focus:border-orange-500 text-2xl text-center">
            </div>
            <p class="text-center text-sm transition" :class="pinWasFilled ? 'text-green-400' : 'text-gray-500'">{{
                pinWasFilled ? 'Ďakujeme, môžete pokračovať kliknutím na tlačidlo' : 'Zadajte 4-miestny PIN' }}</p>
        </Modal>
    </div>
</template>

<script>
    // :style="{backgroundSize: `${user.image ? 'cover' : '60%'}`, backgroundImage: `url(${userImage})`}"
    import {mapState} from 'vuex'
    import {EventBus, fallbackImage, getInicials, isMobile} from "../utils";
    import TimerControl from "../components/TimerControl";

    const DEFAULT_TRANSITION = 'slide-left';
    const DEFAULT_TRANSITION_MODE = 'out-in';
    export default {
        name: "Layout",

        components: {
            TimerControl
        },

        data() {
            return {
                prevHeight: 0,
                transitionName: DEFAULT_TRANSITION,
                transitionMode: DEFAULT_TRANSITION_MODE,
                transitionEnterActiveClass: '',

                loginChecker: null,
                pinCodeModal: false,
                pinWasFilled: false,

                sidebarMenu: !isMobile.any(),
            };
        },

        computed: {
            ...mapState({
                isLoading: state => state.isLoading,
                refCount: state => state.refCount,
                user: state => state.account.user,
                hasDarkMode: state => state.darkMode.enabled
            }),

            userImage() {
                return fallbackImage(this.user)
            },

            canShowSidebar() {
                if (!isMobile.any())
                    return true;

                return this.sidebarMenu;
            }
        },

        created() {
            this.$store.dispatch('getUserData', {token: localStorage.getItem('token')});
            this.loginChecker = setInterval(() => {
                let {exp} = this.$store.getters.getToken;
                let now = moment().unix();
                exp = moment(exp).unix();

                if (exp <= now) {
                    this.logout()
                }
            }, 1000);

            EventBus.$on("userFetched", (user) => {
                if (user.pin_code === null) {
                    this.openPinCodeModal()
                }
            });

            this.$router.beforeEach((to, from, next) => {
                let transitionName = to.meta.transitionName || from.meta.transitionName || DEFAULT_TRANSITION;

                if (transitionName === 'slide') {
                    const toDepth = to.path.split('/').length;
                    const fromDepth = from.path.split('/').length;
                    transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';
                }

                this.transitionMode = DEFAULT_TRANSITION_MODE;
                this.transitionEnterActiveClass = `${transitionName}-enter-active`;

                if (to.meta.transitionName === 'zoom') {
                    this.transitionMode = 'in-out';
                    this.transitionEnterActiveClass = 'zoom-enter-active';
                    document.body.style.overflow = 'hidden';
                }

                if (from.meta.transitionName === 'zoom') {
                    this.transitionMode = null;
                    this.transitionEnterActiveClass = null;
                    document.body.style.overflow = null;
                }

                this.transitionName = transitionName;

                next();
            });

            if (this.$store.getters.darkModeIsEnabled) {
                this.$store.commit("enableDarkMode");
            }
        },

        methods: {
            getInicials(u) {
                return getInicials(u.name, u.image);
            },
            switchDarkMode() {
                this.$store.dispatch("switchDarkMode");
            },
            handleComponent(direction) {
                if (direction === 'right') {
                    this.sidebarMenu = true;
                } else if (direction === 'left') {
                    this.sidebarMenu = false;
                }
            },

            switchMenu() {
                this.sidebarMenu = !this.sidebarMenu;
            },

            pinKeyPress(e) {
                e.preventDefault();
                if (Number.isInteger(parseInt(e.key))) {
                    e.target.value = e.key;
                    if (e.target.name === "input1") {
                        this.$refs.pincode2.focus()
                    } else if (e.target.name === "input2") {
                        this.$refs.pincode3.focus()
                    } else if (e.target.name === "input3") {
                        this.$refs.pincode4.focus()
                    } else {
                        e.target.blur();
                        this.pinWasFilled = true;
                    }
                }
            },

            afterPinCodeModalOpen() {
                this.$refs.pincode1.focus()
            },

            openPinCodeModal() {
                this.pinCodeModal = true
            },

            savePinCodeModal() {
                let pin = [
                    this.$refs.pincode1.value,
                    this.$refs.pincode2.value,
                    this.$refs.pincode3.value,
                    this.$refs.pincode4.value
                ];
                this.$store.dispatch("savePin", pin);
                EventBus.$on("user.pin_saved", () => {
                    this.pinCodeModal = false
                });
            },

            closePinCodeModal() {
                this.pinCodeModal = false;
            },

            logout() {
                this.$store.commit("logout");
                this.$router.push('/')
            },

            beforeLeave(element) {
                this.prevHeight = getComputedStyle(element).height;
            },

            enter(element) {
                const {height} = getComputedStyle(element);
                element.style.height = this.prevHeight;
                setTimeout(() => {
                    element.style.height = height;
                });
            },

            afterEnter(element) {
                element.style.height = 'auto';
            },
        },

        beforeDestroy() {
            clearInterval(this.loginChecker)
        }
    };
</script>

<style lang="scss">
    .sidebar-nav {
        a {
            @apply flex items-center py-2 px-5 w-5/6 rounded-r-full my-2;
            transition: background-color 50ms ease 200ms;
            i {
                @apply mr-4 text-gray-400;
                font-size: 1.25rem;
            }
            &:hover {
                @apply text-gray-700;
            }
            
            &.router-link-active {
                @apply text-orange-500 bg-gray-200;
                i {
                    @apply text-orange-500;
                }
            }
        }
    }
</style>